export default __webpack_public_path__ + "static/media/Thief's Gloves of the Hidden Palace.bc28e561.jpg";